export const FONT_FAMILY = 'Inter, system-ui, sans-serif';

/**
 * Apply a page's text scale to a base font size.
 *
 * Canvas labels are written at fixed sizes chosen against the boxes that hold
 * them; a page can multiply all of them at once so a diagram reads at the size
 * its author wants rather than the size the renderer picked. Whatever a label
 * is measured or spaced against - a line height, a halo box - has to go through
 * here too, or the block stops being centred in what surrounds it.
 *
 * Nodes are not re-measured when the scale changes, which is why the setting
 * offers a short range rather than a free number: a label has to stay inside a
 * box that was sized for it at 1.
 */
export function scaleFont(base: number, scale = 1): number {
  return scale === 1 ? base : Math.max(6, Math.round(base * scale));
}
